import { createCrudPage } from './factories/crud-page.js';

/**
 * Legacy backend reads these entity-context fields as query params;
 * they are not part of the shared AppContext contract.
 * @typedef {import('../contracts/context.js').AppContext & {
 *   type?: string, pid?: string | number, id?: string | number, bcountry?: string
 * }} LegacyAdvertorialContext
 */

export default createCrudPage({
  title: 'Advertorial',
  basePath: '/advertorial',
  defaultSort: { field: 'position', dir: 'asc' },
  columns: [
    { key: 'position', label: 'Position', sortable: true },
    { key: 'client_name', label: 'Client', sortable: true },
    { key: 'superior_name', label: 'Superior', sortable: true },
    { key: 'section_name', label: 'Section', sortable: true },
    { key: 'article_title', label: 'Article', sortable: true },
    { key: 'start', label: 'Start', sortable: true },
    { key: 'finish', label: 'Finish', sortable: true },
  ],
  fields: [
    { key: 'clients_pid', label: 'Client', type: 'async-select',
      optionsUrl: '/clients/options' },
    { key: 'superior', label: 'Article Superior', type: 'async-select',
      optionsUrl: '/article-superiors/options' },
    { key: 'section', label: 'Article Section', type: 'async-select',
      optionsUrl: '/article-sections/options', dependsOn: ['superior'] },
    { key: 'article_id', label: 'Article', type: 'async-select',
      optionsUrl: '/articles/options', dependsOn: ['section'] },
    // Legacy sends superior value as ?position= (not ?superior=) to this endpoint
    { key: 'position', label: 'Position', type: 'async-select',
      optionsUrl: '/advertorial-positions/options',
      dependsOn: ['superior'], valuesParams: { superior: 'position' },
      fieldInfo: "You can always take a look at positions <a href='/assets/advertorials.jpg' target='_blank'>here</a>. Red stands for News, green for My company" },
    { key: 'start', label: 'Start', type: 'datetime' },
    { key: 'finish', label: 'Finish', type: 'datetime' },
  ],
  fetchParams: (ctx) => {
    const legacy = /** @type {LegacyAdvertorialContext} */ (ctx.services.context);
    return {
      type: legacy.type,
      pid: legacy.pid,
      id: legacy.id,
      bcountry: legacy.bcountry,
    };
  },
});
